module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-900.woff2?f030f5cfef05f4e5bc834075ec3a6a91";